import React, { FC } from 'react';
import { UseTableColumnsParams } from '@v2/pages/common/components/NCFileBatchEvents/types';
import { EventStatusSubStatusExecModeProps } from '@v2/pages/common/components/NCFileBatchEvents/components/EventStatusSubStatusExecMode';
import ReadyPcsQuantity from '@components/common/ReadyPcsV2/components/ReadyPcsQuantity';

export interface QuantityCellProps extends Pick<UseTableColumnsParams, 'C'>, Pick<EventStatusSubStatusExecModeProps, 'event'> {}

const QuantityCell: FC<QuantityCellProps> = ({ event, C }) => {
  return (
    <ReadyPcsQuantity
      C={C}
      colorForQuantityProduced={'Label/Light/Primary'}
      colorForQuantityTarget={'Label/Light/Tertiary'}
      fontForQuantityProduced={'Time 3'}
      fontForQuantityTarget={'Time 4'}
      spaceBeforePcs
      quantityProduced={event?.productionBatchQuantityCumulative ?? ''}
      quantityTarget={event?.productionBatchQuantityTotal ?? ''}
      batch={null}
    />
  );
};

export default React.memo(QuantityCell, (prev, next) => {
  return (
    prev.event.productionBatchQuantityCumulative === next.event.productionBatchQuantityCumulative &&
    prev.event.productionBatchQuantityTotal === next.event.productionBatchQuantityTotal &&
    prev.C.scheme === next.C.scheme
  );
});
